import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './failure.component.html',
  styleUrls: ['./failure.component.css']
})
export class FailureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
